import {
  Organization,
  OrganizationVaProfile,
  VAStatus,
  VaOnboardingType,
} from "schemas/dashboard";
import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

import { TemplateHighlight } from "features/Influencer/Templates/TemplatesTable/CreateTemplate/PresetFlow/schema";

export function vaOnboardingNavigate(
  currentPathname: string,
  direction: "next" | "back",
  onboardingType?: VaOnboardingType,
  noActiveVaPlan = false,
  hasPaidForSupportCall = false,
) {
  const isPaidPortalPage = currentPathname.endsWith(routes.vaPaidPortal);
  let steps = [
    routes.aboutVaOnboarding,
    routes.categoryVaOnboarding,
    routes.incomeOnboarding,
    routes.vaIntroduction,
  ];
  if (noActiveVaPlan || isPaidPortalPage) {
    steps = [...steps, routes.vaPaidPortal];
  }
  steps = [...steps, routes.vaStepsToGetStarted];
  if (!hasPaidForSupportCall) {
    steps = [...steps, routes.vaOnboardingType];
  }
  steps = [
    ...steps,
    routes.vaVideoOverview,
    routes.vaOnboardingNichePick,
    routes.vaOnboardingNicheDetails,
  ];
  if (onboardingType !== VaOnboardingType.book_call) {
    steps = [...steps, routes.vaOnboardingBackground];
  }
  steps = [
    ...steps,
    routes.vaOnboardingSocials,
    routes.vaOnboardingFinalTouch,
    routes.vaFaq,
    routes.dashboard,
  ];
  const currentStep = steps.findIndex((step) => currentPathname.endsWith(step));
  if (direction === "next" && currentStep < steps.length - 1) {
    return steps[currentStep + 1];
  } else if (direction === "back" && currentStep > 0) {
    return steps[currentStep - 1];
  } else {
    return currentPathname;
  }
}

export function getOnboardingPage(currentPathname: string) {
  if (currentPathname.endsWith(routes.welcomeOnboarding)) {
    return "welcomePage";
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    return "aboutForm";
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    return "categoryForm";
  } else if (currentPathname.endsWith(routes.selectBrandOnboarding)) {
    return "selectBrandForm";
  } else if (currentPathname.endsWith(routes.pitchOnboarding)) {
    return "pitchForm";
  } else if (currentPathname.endsWith(routes.socialMediaLinksOnboarding)) {
    return "socialMediaLinksForm";
  } else if (currentPathname.endsWith(routes.pitchingGoalOnboarding)) {
    return "pitchingGoalForm";
  } else if (currentPathname.endsWith(routes.currentPitchOnboarding)) {
    return "currentPitchForm";
  } else if (currentPathname.endsWith(routes.pitchingHighlightOnboarding)) {
    return "pitchingHighlightsForm";
  } else if (currentPathname.endsWith(routes.portfolioOnboarding)) {
    return "portfolioForm";
  } else if (currentPathname.endsWith(routes.partnershipsOnboarding)) {
    return "partnershipForm";
  } else if (currentPathname.endsWith(routes.engagementOnboarding)) {
    return "engagementForm";
  } else if (currentPathname.endsWith(routes.standOutOnboarding)) {
    return "standOutForm";
  } else if (currentPathname.includes(routes.emailOnboarding)) {
    return "emailBrandForm";
  }
}

export function onboardingNavigate(
  currentPathname: string,
  onboardingForm: Map,
  direction: "next" | "back",
) {
  if (currentPathname.endsWith(routes.welcomeOnboarding)) {
    // only forward
    return routes.aboutOnboarding;
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    // only forward
    if (direction === "next") {
      return routes.categoryOnboarding;
    }
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    if (direction === "next") {
      return routes.selectBrandOnboarding;
    } else {
      return routes.aboutOnboarding;
    }
  } else if (currentPathname.endsWith(routes.selectBrandOnboarding)) {
    if (direction === "back") {
      return routes.categoryOnboarding;
    } else {
      return routes.pitchOnboarding;
    }
  } else if (currentPathname.endsWith(routes.pitchOnboarding)) {
    if (direction === "next") {
      if (!onboardingForm.hasPitchEmail) {
        return routes.pitchingGoalOnboarding;
      } else {
        return routes.socialMediaLinksOnboarding;
      }
    } else {
      return routes.selectBrandOnboarding;
    }
  } else if (currentPathname.endsWith(routes.socialMediaLinksOnboarding)) {
    if (direction === "next") {
      if (!onboardingForm.hasPitchEmail) {
        if (
          (!onboardingForm.defaultTemplateHighlights ||
            onboardingForm.defaultTemplateHighlights.length === 0 ||
            onboardingForm.defaultTemplateHighlights?.includes(
              TemplateHighlight.PORTFOLIO,
            )) &&
          !onboardingForm.portfolioUrl
        ) {
          return routes.portfolioOnboarding;
        } else if (
          onboardingForm.defaultTemplateHighlights?.includes(
            TemplateHighlight.CASE_STUDY,
          ) ||
          onboardingForm.defaultTemplateHighlights?.includes(
            TemplateHighlight.PAST_PARTNERSHIPS,
          )
        ) {
          return routes.partnershipsOnboarding;
        } else if (
          onboardingForm.defaultTemplateHighlights?.includes(
            TemplateHighlight.ENGAGEMENT_NUMBERS,
          )
        ) {
          return routes.engagementOnboarding;
        } else {
          return routes.standOutOnboarding;
        }
      } else {
        return routes.currentPitchOnboarding;
      }
    } else {
      if (!onboardingForm.hasPitchEmail) {
        return routes.pitchingHighlightOnboarding;
      } else {
        return routes.pitchOnboarding;
      }
    }
  } else if (currentPathname.endsWith(routes.pitchingGoalOnboarding)) {
    if (direction === "next") {
      return routes.pitchingHighlightOnboarding;
    } else {
      return routes.pitchOnboarding;
    }
  } else if (currentPathname.endsWith(routes.pitchingHighlightOnboarding)) {
    if (direction === "next") {
      return routes.socialMediaLinksOnboarding;
    } else {
      return routes.pitchingGoalOnboarding;
    }
  } else if (currentPathname.endsWith(routes.portfolioOnboarding)) {
    if (direction === "next") {
      if (
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.CASE_STUDY,
        ) ||
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.PAST_PARTNERSHIPS,
        )
      ) {
        return routes.partnershipsOnboarding;
      } else if (
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.ENGAGEMENT_NUMBERS,
        )
      ) {
        return routes.engagementOnboarding;
      } else {
        return routes.standOutOnboarding;
      }
    } else {
      return routes.socialMediaLinksOnboarding;
    }
  } else if (currentPathname.endsWith(routes.partnershipsOnboarding)) {
    if (direction === "next") {
      if (
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.ENGAGEMENT_NUMBERS,
        )
      ) {
        return routes.engagementOnboarding;
      } else {
        return routes.standOutOnboarding;
      }
    } else {
      return routes.socialMediaLinksOnboarding;
    }
  } else if (currentPathname.endsWith(routes.engagementOnboarding)) {
    if (direction === "next") {
      return routes.standOutOnboarding;
    } else {
      if (
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.CASE_STUDY,
        ) ||
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.PAST_PARTNERSHIPS,
        )
      ) {
        return routes.partnershipsOnboarding;
      } else {
        return routes.socialMediaLinksOnboarding;
      }
    }
  } else if (currentPathname.endsWith(routes.standOutOnboarding)) {
    // only back
    if (direction === "back") {
      if (
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.ENGAGEMENT_NUMBERS,
        )
      ) {
        return routes.engagementOnboarding;
      } else if (
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.CASE_STUDY,
        ) ||
        onboardingForm.defaultTemplateHighlights?.includes(
          TemplateHighlight.PAST_PARTNERSHIPS,
        )
      ) {
        return routes.partnershipsOnboarding;
      } else {
        return routes.socialMediaLinksOnboarding;
      }
    }
  } else if (currentPathname.endsWith(routes.currentPitchOnboarding)) {
    // only back
    if (direction === "back") {
      return routes.socialMediaLinksOnboarding;
    }
  } else if (currentPathname.includes(routes.emailOnboarding)) {
    // only back
    if (direction === "back") {
      if (onboardingForm.hasPitchEmail) {
        return routes.currentPitchOnboarding;
      } else {
        return routes.standOutOnboarding;
      }
    }
  }
}

export const getVaOnboardingRoute = (
  organization: Organization,
  vaProfile: OrganizationVaProfile,
  link: string,
) => {
  // Edge case, user clicked an Import link in an email.
  if (link?.includes(routes.tracking)) {
    return link;
  }
  const isOnboarding =
    organization.vaStatus === VAStatus.pending ||
    (organization.signedUpForVa &&
      organization.vaStatus !== VAStatus.not_interested &&
      organization.vaStatus !== VAStatus.disqualified);
  if (!isOnboarding) return "";
  if (vaProfile?.onboardingType === VaOnboardingType.self_serve) {
    return `/${routes.onboardingVaSelfServe}`;
  } else {
    return `/${routes.onboardingVaInfluencer}`;
  }
};
